import React from 'react';

import {ITagPanelIcon} from './types';
import style  from './style.module.css';
import IconsService from "external-services/icons-service/icons.service";
import classNames from 'classnames';

export enum TagColors {
  Black = '#000000',
  Red = '#b51b00',
  Purple = '#9220d7',
  Orange = '#D79A20',
  Green = '#2CB90D',
  Blue = '#206ED7',
}

const TagPanelIcon = (props: ITagPanelIcon) => {
  const {
    tag
  } = props;

  const {
    dynamicIconName,
    iconType,
    isRisky,
    colour,
  } = tag;

  let iconStyles: any = {};

  if(iconType) {
    iconStyles = {
      fontSize: '1.6rem',
    }
    // if(isRisky) iconStyles.color = color;
  } else {
    iconStyles = {
      WebkitMask: `url(images/tags/${dynamicIconName}.svg) no-repeat 0 0/1.6rem ${1.6}rem`,
      mask: `url(images/tags/${dynamicIconName}.svg) no-repeat 0 0/1.6rem ${1.6}rem`,
    }
    // if(isRisky) iconStyles.background = color;
  }
    iconStyles.background = colour || '#808080';

  const IconFromType: any =  iconType ?
    IconsService.getIcon(tag.iconType)
    :
    null

  return (
    <div className={style.tagIcon}>
      {
        iconType &&
        <IconFromType style={iconStyles} className={classNames({
          [style.matIcon]: true,
        })}/>
      }
      {
        !iconType &&
        <span
          style={iconStyles}
          className={classNames({
            [style.dynamicIcon]: true,
          })}
        />
      }
    </div>
  );
}
export default TagPanelIcon;
